import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const GivenName = (props) => {
  return (
    <FormGroup>
      <Col componentClass={ControlLabel} sm={5}>
        Given Name
      </Col>
      <Col sm={7}>
          <FormControl
            name="givenName"
            type="text"
            value={props.givenName}
            onChange={props.handleChangeGivenName}
            disabled={props.disabled}
            autoComplete="off"
          />
      </Col>
    </FormGroup>
  )
}

GivenName.propTypes = {
  givenName: PropTypes.string,
  handleChangeGivenName: PropTypes.func,
  disabled: PropTypes.bool,
};

export default GivenName;



// WEBPACK FOOTER //
// ./src/app/components/quotationCVComponent/givenName/GivenName.js